import { Identifiable, Notification } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function editNotificationsStatus(httpClient: HttpClient) {
  return (notifications: Identifiable<Notification>[]) =>
    httpClient.sendHttpRequest<void>({
      endpoint: "/resourceNotifications/mark-as-read",
      method: HttpMethods.PATCH,
      data: {
        resourceNotificationsUuid: notifications.map(({ uuid }) => uuid),
      },
    });
}

export { editNotificationsStatus };
